import {
  useCallback,
 useEffect, useMemo, useRef, useState,
} from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd';

import devicesApi from '@api/devicesApi';
import deviceActions from '@state/device/actions';
import clientsAction from '@state/client/actions';
import telemetryActions from '@state/telemetry/actions';

import getColumnsDevices from '../../../HomeDispositivo/containers/DeviceListTable/getColumns';
import getColumnsClients from '../../../Clientes/columnsClientes';

function useDashboardAdmin() {

  const { business_type_id } = useParams();
  const history = useHistory();

  const abortController = useRef(null);
  abortController.current = new AbortController();
  const { signal } = abortController.current;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const deviceRedux = useSelector(({ device: a }) => a.createNewDevice);
  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const [loading, setLoading] = useState(true);
  const [loadingBusiness, setLoadingBusiness] = useState(true);

  const [businessData, setBusinessData] = useState(true);

  // AMI IoT
  const [valueFilterDevices, setValueFilterDevices] = useState('');
  const [statusDevices, setStatusDevices] = useState('todos');

  // Clients
  const [valueFilterClients, setValueFilterClients] = useState('');
  const [clients, setClients] = useState([]);

  const getAllBusinessType = useCallback( // load device data
    () => {

      setLoading(true);
      setLoadingBusiness(true);

      const offset = 0;
      const limit = 1000;

      // devicesTelemetry
      devicesApi.getAllBusinessTypeById({
        signal, offset, limit, business_type_id,
      }).then(async (response) => {

        if (response?.length > 0) {

          console.log(response[0]);
          setBusinessData(response[0]);

}

        setLoading(false);
        setLoadingBusiness(false);

      })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);
          setLoadingBusiness(false);

        });

    },
    [],
  );

  const getAllclient = useMemo(() => () => {

    setLoading(true);
    const skip = 0;
    const limit = 1000;

    let businessTypeIdsQuery = '';

    if (business_type_id !== '') {

      businessTypeIdsQuery += `business_type_id=${business_type_id}`;

}

    devicesApi.getAllClientsByBusiness(signal, skip, limit, businessTypeIdsQuery)
        .then(async (response) => {

           const newClient = await Promise.all(response.map(async (obj) => {

            const devices_total = obj?.devices?.length;
            const business_type_name = obj?.business_type?.name;
            const item = { ...obj, business_type_name, devices_total };
            return item;

          }));

          setClients(newClient);

           setLoading(false);

        })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);

        });

  }, [setClients]);

  const arrayFilterAux = [];
    clients.forEach((value, index) => { // remove current user

    arrayFilterAux.push(value);

});

  const createDevice = useCallback( // Go to create /crear-dispositivo
    () => {

      history.push('/dispositivos/crear-dispositivo');

    },
    [history],
  );

  const viewMetrica = useCallback((e) => {

    history.push('/metricas');

}, []);

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  const arrayFilterDevices = businessData?.devicesList?.filter((data) => {

    const nameFilter = data.name.toUpperCase().includes(valueFilterDevices.toUpperCase());

    // Si el valor seleccionado es "todos", no apliques el filtro por estado
    if (statusDevices === 'todos') {

          return nameFilter; // Retornar el resultado del filtro por nombre

}

    // Si el valor seleccionado es "conectados", filtra por estado "Connected"
    if (statusDevices === 'conectados') {

      return (
        nameFilter
        && data.device_twin?.connection_state === 'Connected'
      );

}

    // Si el valor seleccionado es "desconectados", filtra por estado "Disconnected"
    if (statusDevices === 'desconectados') {

      return (
        nameFilter
        && data.device_twin?.connection_state === 'Disconnected'
      );

}

    return false; // Si no coincide con ninguno de los casos anteriores, no mostrarlo

});

  const deleteDevice = useCallback((e) => { // Delete device by Id

    const { id } = e;
    devicesApi.deleteDeviceById({ signal, id })
      .then((response) => {

        message.success(t('common.feedbacks.device_remove_success'));
        getAllBusinessType();

      })
      .catch((error) => {

        message.error(t('common.feedbacks.device_remove_failed'));

      });

  // eslint-disable-next-line
  }, []);

  const editDevice = useCallback((e) => { // edit device, save data device in redux

    const defaultData = {
      name: e.name,
      client: e.client,
      business_type_id: e?.business_type?.id || '',
      device_type_id: e?.device_types?.map((item) => (item.id)) || [],
      slvId: `${e?.slvId}` || '',
      gateway_id: e?.gateway?.id || '',
    };

    dispatch(deviceActions.setDeviceIdEdit(e.id));
    dispatch(deviceActions.setCreateEditDevice(defaultData));
    history.push('/dispositivos/editar-dispositivo');

  }, [dispatch, history]);

  const goToDeviceId = useCallback((device) => {

    // Route viejo
    /// /tablero-gener''al/almacenamiento/:device

    // Route Nuevo
    /// /tablero-general/:device
    // eslint-disable-next-line
    if (device?.business_type?.name.trim() === 'Retail' || device?.business_type?.name.trim() === 'Almacenamiento') {

      dispatch(telemetryActions.setDeviceId(device.id));
      history.push(`/tablero-general/almacenamiento/${device.id}`);

    } else {

      dispatch(telemetryActions.setDeviceId(device.id));
      history.push(`/tablero-general/${device.id}`);

    }
    // eslint-disable-next-line
  }, []);

  const columnsDevices = useMemo(
    () => getColumnsDevices(t, deleteDevice, editDevice, currentUser, goToDeviceId),
    [t, deleteDevice, editDevice, currentUser, goToDeviceId],
  );

  const createClient = useCallback( // Go to create /crear-dispositivo
  () => {

    history.push('/clientes/crear-cliente');

}, [history],
);

  const arrayFilterClients = arrayFilterAux?.filter((client) => (
    client && (
      // eslint-disable-next-line
      client.description.toUpperCase().includes(valueFilterClients.toUpperCase())
      // eslint-disable-next-line
      || (client.celsia_id && client.celsia_id.toUpperCase().includes(valueFilterClients.toUpperCase()))
      // eslint-disable-next-line
      || (client.third_id && client.third_id.toUpperCase().includes(valueFilterClients.toUpperCase()))
    )
  ));

  const viewClient = useCallback((e) => {

    dispatch(clientsAction.setDashboardClient(true));
    history.push(`/clientes/${e.id}`);

}, []);

  const deleteClient = useCallback((e) => {

    const { id } = e;

    setLoading(true);
    devicesApi.deleteClientById({ signal, id })
      .then((response) => {

        setLoading(false);
        message.success(t('forms.clients.feedbacks.delete_success'));
        getAllBusinessType();

      })
      .catch((error) => {

        setLoading(false);
        message.error(t('forms.clients.feedbacks.delete_failed'));

      });

}, []);

  const editClient = useCallback((e) => { // edit device, save data device in redux

    const {
      id, celsia_id,
      third_id,
      description,
      stratum,
      business_type_id: bType, // Renombrar la variable aquí
      representative,
      devices,
    } = e;

    const defaultData = {
      celsia_id,
      third_id,
      description,
      stratum,
      business_type_id: bType, // Usar el nuevo nombre aquí
      representative,
      devices_id: devices.map((item) => item.id)[0] || '',
    };

    dispatch(clientsAction.setClientIdEdit(id));
    dispatch(clientsAction.setCreateEditClient(defaultData));

    history.push('/clientes/editar-cliente');

}, [dispatch, history]);

  const columnsClients = useMemo(
    // eslint-disable-next-line
    () => getColumnsClients(t, currentUser, deleteClient, editClient, viewClient), [t, currentUser, deleteClient, editClient, viewClient],
);

  useEffect(() => {

    // Guardo el negocio si se va a crear ya tenerlo
    const newDevice = { ...deviceRedux, business_type_id };
    dispatch(deviceActions.setCreateEditDevice(newDevice));

    getPermissonCreate();
    getAllBusinessType();
    getAllclient();

}, []);

  return {
    loading,
    loadingBusiness,
    isCreate,
    businessData,
    setStatusDevices,
    setValueFilterDevices,
    createDevice,
    arrayFilterDevices,
    columnsDevices,
    arrayFilterClients,
    setValueFilterClients,
    columnsClients,
    createClient,
    viewMetrica,
  };

}

export default useDashboardAdmin;
